import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
const TOKEN_KEY = "seo_studio_jwt";
const USER_KEY = "seo_studio_user";

export const seoApi = axios.create({
  baseURL: `${BACKEND}/api`,
  headers: { "Content-Type": "application/json" },
});

seoApi.interceptors.request.use((cfg) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) cfg.headers["Authorization"] = `JWT ${token}`;
  return cfg;
});

seoApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
      if (!window.location.pathname.startsWith("/seo-studio/login")) {
        window.location.href = "/seo-studio/login";
      }
    }
    return Promise.reject(err);
  },
);

export async function login(email, password) {
  const res = await axios.post(
    `${BACKEND}/api/cms/api/users/login`,
    { email, password },
    { headers: { "Content-Type": "application/json" } },
  );
  const { token, user } = res.data || {};
  if (!token) throw new Error("login response missing token");
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user || {}));
  return user;
}

export function logout() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function currentUser() {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || "null");
  } catch {
    return null;
  }
}

export function isAuthenticated() {  return !!localStorage.getItem(TOKEN_KEY);
}

export function authHeader() {
  const token = localStorage.getItem(TOKEN_KEY);
  return token ? { Authorization: `JWT ${token}` } : {};
}

export function backendUrl(path) {
  return `${BACKEND}${path.startsWith("/") ? path : "/" + path}`;
}
